export const cilBluetooth = ["24 24","<path d='M18.311 6.375l-5.625-5.625h-1.811v9.439l-3.814-3.814h-2.121l5.625 5.625-5.625 5.625h2.121l3.814-3.814v9.439h1.811l5.625-5.625-5.625-5.625zM12.375 2.561l3.814 3.814-3.814 3.814zM16.189 17.625l-3.814 3.814v-7.629z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-bluetooth.js
// module id = null
// module chunks = 